module.exports = __webpack_public_path__ + "media/images/sp/plans/mv_flower@2x-f3bd9e5a8de4de7ac5062f73ddad01c9.webp";